/**
 * The performance overlay's labels (ADR-087): the page's own figures, the server's and the zone's, which the F8 view
 * and the staff viewer's counts share. They name numbers for a developer and a GM, so they stay terse.
 */
export const PERF = {
  title: "Performance",
  server: "Server",
  zone: "Zone",
  area: "Area",
  unknown: "-",
  client: { fps: "FPS", frame: "Frame", objects: "Objects", props: "Props", players: "Players", creatures: "Creatures", things: "Things", received: "Received", ping: "Ping" },
  rows: { tick: "Tick", clients: "Clients", perClient: "Per client", near: "Near", tiers: "Tiers" },
  table: { characters: "Characters", creatures: "Creatures", awake: "Awake", things: "Things" },
} as const;
